import {AgentView, GroupView} from '@ozark/common';
import {parse} from 'date-fns';
import {format} from 'date-fns-tz';

export const getFullName = (agent: AgentView) =>
  `${agent.firstName || ''} ${agent.lastName || ''}`.trim();

export const agentNameComparer = (a: AgentView, b: AgentView) =>
  getFullName(a).localeCompare(getFullName(b));

export const groupNameComparer = (a: GroupView, b: GroupView) => a.name.localeCompare(b.name);

export const getAgentNames = (agent: AgentView): string => {
  return `${agent?.firstName} ${agent?.lastName}`.trim();
};

export const getAgentDropDownTitle = (agent?: AgentView): string => {
  return agent ? getAgentNames(agent) : 'All Agents';
};

export const getGroupDropDownTitle = (group?: GroupView): string => {
  return group ? group.name : 'All Groups';
};

export const formatYearMonth = (yearMonth: string) => {
  const date = parse(yearMonth as string, 'yyyyMM', new Date());
  return format(date, 'MMMM, yyyy');
};
